// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2_frR","actionsCol":"EnrolledClinics_actionsCol__7TarW"};